import script from "./ProjectDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=5b5a5ad3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5a5ad3"]])

export default __exports__